import { Button, Collapse, List, ListItem, ListItemIcon, ListItemText, Menu, MenuItem } from "@material-ui/core";
import { AccountCircle, ExpandMore, Language, Translate, TranslateOutlined } from "@material-ui/icons";
import moment from "moment";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { withFirebase } from "../Firebase";

const LangSelect = (props) => {
    const { icon, menu, closeMenu, firebase } = props;
    const [anchorEl, setAnchorEl] = useState(null);
    const [menuOpen, setMenuOpen] = useState(false);
    const open = Boolean(anchorEl);
    const { t, i18n } = useTranslation();

    const handleMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const onChangeLanguaje = (lang) => {
        i18n.changeLanguage(lang);
        moment.locale(lang);
        try {
            firebase.setUserLang(lang);
        } catch (error) {
            console.log("no se ha podido cambiar el idioma en la BD", error);
        }

        menu && closeMenu(false);
        menu && setMenuOpen(false);
    };

    if (menu) {
        return (
            <>
                <MenuItem onClick={() => setMenuOpen(!menuOpen)}>
                    <ListItemIcon>
                        <Language color="primary" />
                    </ListItemIcon>
                    <ListItemText>{t("languaje")}</ListItemText>
                    <ExpandMore style={{ transform: `rotate(${menuOpen ? 180 : 0}deg)`, transition: ".25s cubic-bezier(0.4, 0.0, 0.2, 1)" }} />
                </MenuItem>
                <Collapse in={menuOpen} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                        <MenuItem
                            button
                            onClick={() => {
                                onChangeLanguaje("es");
                                closeMenu(false);
                            }}
                        >
                            <ListItemText>{t("lang.spanish")}</ListItemText>
                        </MenuItem>
                        <MenuItem button onClick={() => onChangeLanguaje("eu")}>
                            <ListItemText>{t("lang.basque")}</ListItemText>
                        </MenuItem>
                        <MenuItem button onClick={() => onChangeLanguaje("en")}>
                            <ListItemText>{t("lang.english")}</ListItemText>
                        </MenuItem>
                    </List>
                </Collapse>
            </>
        );
    } else {
        return (
            <>
                <Button
                    aria-label="account of current user"
                    aria-controls="menu-appbar"
                    aria-haspopup="true"
                    type="text"
                    onClick={handleMenu}
                    color="inherit"
                    style={{ textTransform: "none" }}
                >
                    {icon && <Language style={{ marginRight: 6 }} />}
                    {menu ? (
                        t("languaje")
                    ) : (
                        <>
                            {t("navigation.languaje.current")}
                            <ExpandMore />
                        </>
                    )}
                </Button>
                <Menu
                    id="menu-appbar"
                    anchorEl={anchorEl}
                    anchorOrigin={{
                        vertical: "top",
                        horizontal: "right",
                    }}
                    keepMounted
                    transformOrigin={{
                        vertical: "top",
                        horizontal: "right",
                    }}
                    open={open}
                    onClose={handleClose}
                >
                    <MenuItem
                        button
                        onClick={() => {
                            setAnchorEl(false);
                            onChangeLanguaje("es");
                        }}
                    >
                        <ListItemText>{t("lang.spanish")}</ListItemText>
                    </MenuItem>
                    <MenuItem button onClick={() => (onChangeLanguaje("eu"), setAnchorEl(null))}>
                        <ListItemText>{t("lang.basque")}</ListItemText>
                    </MenuItem>
                    <MenuItem button onClick={() => (onChangeLanguaje("en"), setAnchorEl(null))}>
                        <ListItemText>{t("lang.english")}</ListItemText>
                    </MenuItem>
                </Menu>
            </>
        );
    }
};

export default withFirebase(LangSelect);
